import type React from 'react';

import { useConsultation } from '@src/entities/consultations';

type Props = {
	id: number;
};

export const ConsultationType: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	const types: { [x: string]: string } = {
		ON: 'Онлайн',
		OF: 'Личный приём',
	};
	return <>{consultation && types[consultation.type]}</>;
};
